import { useCallback } from 'react';

import { useVideoContext } from '../../../context';

type Args = {
	stopRecording: () => void;
	getElapsedSeconds: () => number | undefined;
	setVideoSource: (source: 'recorder') => void;
};

/**
 * Ends a take: stop the recorder, and record how long it ran and where it came from.
 *
 * Where the supporter goes next is the caller's business - the recorder screen moves on to the preview,
 * `v2_consolidated` reviews the take in place - but these three always happen together. Shared because
 * `recordedDurationSec` is easy to forget and expensive to miss: without it the upload's duration check
 * cannot measure the take, and reports an error to Sentry on every submit.
 */
export function useFinishTake({ stopRecording, getElapsedSeconds, setVideoSource }: Args): () => void {
	const {
		actions: { setRecordedDurationSec },
	} = useVideoContext();

	return useCallback(() => {
		stopRecording();
		setRecordedDurationSec(getElapsedSeconds());
		setVideoSource('recorder');
	}, [getElapsedSeconds, setRecordedDurationSec, setVideoSource, stopRecording]);
}
